import React from "react";
import { withFormik, Form } from "formik";
import { func, bool, shape } from "prop-types";
import { Col } from "react-bootstrap";
import classNames from "classnames";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { compose } from "redux";

import { selectors as fundcorpSelectors, actions as fundcorpActions } from "reducers/fundcorp";
import * as i18nUtils from "util/i18n";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import Head from "pages/_components/Head";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import { resizableRoute } from "pages/_components/Resizable";
import { useEmbeddedV3ShellLayoutSync } from "util/v3ShellLayoutSync";
import SubscribeSummaryData from "./SubscribeSummaryData";

function FundSubscribeSummary({ isDesktop, dispatch, isSubmitting, summary, embeddedInV3Shell }) {
    const { selectedFund, numFund, fundName, shareAccount } = summary;

    useEmbeddedV3ShellLayoutSync(dispatch, {
        embeddedInV3Shell,
        isDesktop,
        titleKey: "fund.subscribe.summary.label",
        goBackPath: "/fundcorpOperations",
        scopes: ["subscribeSummary"],
    });

    const handleBack = () => {
        dispatch(push(`/fundcorpOperations/subscribe/${selectedFund?.numero || numFund}/${shareAccount}`));
    };

    const confirmButton = (
        <Col className="confirmation__content-button" lg={12} md={12} sm={12}>
            <div className="admin-content-center">
                <Button
                    image="images/arrowRight.svg"
                    imageStyle={isDesktop ? "mr-2" : "mr-1"}
                    type="submit"
                    bsStyle="primary"
                    label="global.confirm"
                    loading={isSubmitting}
                />
            </div>
        </Col>
    );

    if (!fundName) {
        handleBack();
    }
    return (
        <>
            {!embeddedInV3Shell && <Notification scopeToShow="subscribeSummary" />}
            {!(embeddedInV3Shell && !isDesktop) && (
                <div className="admin-detail-head px-0">
                    <Head
                        onBack={handleBack}
                        title={!isDesktop && "fund.subscribe.summary.label"}
                        titleClassName="text-white"
                        accessibilityTextId="fund.subscribe.summary.label"
                        headerClassName={classNames({
                            "blue-main-header-mobile": !isDesktop,
                        })}
                        centerContentClassName={classNames({
                            "mx-5": !isDesktop,
                        })}
                    />
                    {isDesktop && <h1 className="mt-1 mb-3">{i18nUtils.get("fund.subscribe.summary.label")}</h1>}
                </div>
            )}
            <Form className="confirmation__container">
                <Container
                    className={classNames({
                        "mb-9 flex-grow align-items-center cmf-container-white pt-3": !isDesktop,
                    })}
                    gridClassName={!isDesktop ? "form-content" : "confirmation__form confirmation__box"}>
                    <div
                        className={classNames("admin-content-center", {
                            "mb-3 px-4": !isDesktop,
                        })}>
                        <I18n
                            id="fund.subscribe.summary.checkInfo.label"
                            component={!isDesktop ? "h2" : "h1"}
                            componentProps={{ className: classNames({ "f-size-35": !isDesktop }) }}
                        />
                    </div>
                    <Col className={`col-12 ${!isDesktop && "pt-3 mt-3"}`} lg={12} md={9} sm={12}>
                        <SubscribeSummaryData isDesktop={isDesktop} />
                        <div className="admin-content-center">
                            <I18n
                                id="confirmation.withoutotp.text"
                                component="p"
                                componentProps={{ className: "confirmation__text-without-otp" }}
                            />
                        </div>
                    </Col>
                    <Container className="flex-grow align-items-center w-100" gridClassName="form-content">
                        {confirmButton}
                    </Container>
                </Container>
            </Form>
        </>
    );
}

FundSubscribeSummary.propTypes = {
    dispatch: func.isRequired,
    isDesktop: bool,
    isSubmitting: bool,
    summary: shape({}).isRequired,
    embeddedInV3Shell: bool,
};

FundSubscribeSummary.defaultProps = {
    embeddedInV3Shell: false,
    isDesktop: true,
    isSubmitting: false,
};

const mapStateToProps = (state) => ({
    summary: fundcorpSelectors.getSummary(state),
});

export default compose(
    connect(mapStateToProps),
    resizableRoute,
    withFormik({
        handleSubmit: (_, formikBag) => {
            const { dispatch, summary } = formikBag.props;

            dispatch(
                fundcorpActions.sendSubscribeRequest(
                    { ...summary, idActivity: "fundcorp.register.suscription.request" },
                    formikBag,
                ),
            );
        },
    }),
)(FundSubscribeSummary);
